import { tss } from "tss-react";
import commonStyles from "styles/common";

const useStyles = tss.create({
    root: {
        width: 16,
        height: 16,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
    },
});

type IColorBand = {
    background: string;
    color?: string;
    label?: string;
    width?: number;
};

export default function ColorBand(props: IColorBand) {
    const { classes } = useStyles();
    const { classes: common } = commonStyles();
    const { background, color, label, width } = props;
    return (
        <div
            className={[classes.root, common.label].join(" ")}
            style={{
                backgroundColor: background,
                color: color ? color : "white",
                width: width ? width : 16,
            }}
        >
            {label}
        </div>
    );
}
